class TimeMetric {
    constructor(bins) {
        this.data = []
        this.lastFrame = null

        this.intervalStartTime = null
        this.bins = bins

        this.histogram = null
        if (Array.isArray(this.bins)) {
            this.histogram = this.bins.map(() => 0.0)
        }
        this.valuesCount = 0
    }

    intervalStart() {
        this.intervalStartTime = performance.now()
    }

    intervalStop() {
        const timeNow = performance.now()
        const interval = timeNow - this.intervalStartTime
        this.addValue(interval)
    }

    addValue(value) {
        if (!Array.isArray(this.bins)) {
            return
        }
        this.valuesCount += 1
        for (let i = 0; i < this.bins.length; i += 1) {
            const lowerLimit = i > 0 ? this.bins[i - 1].value : 0.0
            const upperLimit = this.bins[i].value !== null ? this.bins[i].value : Infinity
            if (value > lowerLimit && value <= upperLimit) {
                this.histogram[i] += 1
                break
            }
        }
    }
}

export default TimeMetric
